import { Field, Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

type OttaConfig = {
  username: string;
  password: string;
};

export const OttaConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as OttaConfig) ?? {
    username: "",
    password: ""
  };

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Username">
        <TextInput
          placeholder="Username"
          value={credentials.username}
          onChange={username =>
            onChange({
              credentials: { ...credentials, username }
            })
          }
        />
      </Field>
      <Field title="Password">
        <TextInput
          placeholder="Password"
          value={credentials.password}
          type="password"
          onChange={password =>
            onChange({
              credentials: { ...credentials, password }
            })
          }
        />
      </Field>
    </Layout.Group>
  );
};
